export default {"src":"/_next/static/media/ishaLogo.6b69eaf8.svg","height":62,"width":76,"blurWidth":0,"blurHeight":0};